import _find from 'lodash/find.js';
import _set from 'lodash/set.js';
import _findIndex from 'lodash/findIndex.js';
import _uppercase from 'lodash/upperCase.js';
import { randomNumber } from '_ui-core-js/utilities/randomNumber.js';

export const extractModelOptionsData = (model, gradeIndex=0, option) => model.cars[gradeIndex][option]?.map(id => _find(model[option], { id }));

export const extractBaseModelSpecsData = (model, value1, value2) => {
  const specsObj = _find(model.specs, { code: value1 });
  const itemsArray = specsObj ? specsObj.items : null;
  const specsData = itemsArray ? _find(itemsArray, { code: value2 }).value : undefined;
  return specsData;
};

export const getInitColor = (model, car, useGrades) => {

  const lbxHeroColourMap = {
    LBX:'1h5',
    ELEGANT:'8w7',
    RELAX:'085',
    EMOTION: '2tb',
    COOL:'2yf',
    ORGINAL: '2yf'
  };

  if ( useGrades ) {
    const gradeName = _uppercase(_find(model.grades, { id: car.grade }).name)
    const colourCode = lbxHeroColourMap[gradeName] || undefined
    _.set(car, 'initColor', colourCode)
  }

  const specifiedInitColor = useGrades ? car.initColor : model.initColor;
  const randomIndex = randomNumber(0, car.colours.length);
  const index = specifiedInitColor ? _findIndex(model.colours, color => color.code === specifiedInitColor) : 0;
  const colorId = model.colours[index].id;
  const gradeHasColor = car.colours.indexOf(colorId) > -1;
  const code = specifiedInitColor && gradeHasColor ? _find(model.colours, {id: colorId}).code : _find(model.colours, {id: car.colours[randomIndex]}).code;

  return {
    index: specifiedInitColor && gradeHasColor ? index : randomIndex,
    code
  }
};

// Dort wheels array by 'option' type first. If the 'short' code is missing in the cardb data, meaning we cannot change wheel type, 
// the default image uses the first options type wheel. Reorder array to make sure first wheel option is the default selection.
export const sortWheelsArray = wheelsArray => {
  if (!wheelsArray) return;

  for (let i=0; i<wheelsArray.length; i++) {
    wheelsArray.push(...wheelsArray.splice(wheelsArray.findIndex(v => v.type == 'accessory'), 1))
  }

  return wheelsArray;
};